import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, BuildingIcon, UsersIcon, ZapIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: CalendarIcon,
    number: '1',
    title: 'Book Online',
    description: 'Schedule your appointment online in minutes. Choose between an office visit or mobile service.'
  }, {
    icon: BuildingIcon,
    number: '2',
    title: 'Office Appointment',
    description: 'Visit our Columbia, MD office for individual fingerprinting services by appointment.'
  }, {
    icon: UsersIcon,
    number: '3',
    title: 'Mobile Service',
    description: 'We travel to your location for group fingerprinting (5 or more people) across Maryland.'
  }, {
    icon: ZapIcon,
    number: '4',
    title: 'Fast Processing',
    description: 'Fingerprints are captured and submitted electronically. Results are typically processed within 24–48 hours.'
  }];
  return <section className="py-12 lg:py-20 bg-white border-b border-slate-100" aria-labelledby="how-it-works-heading" data-id="element-114">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
        <div className="text-center mb-16 lg:mb-20" data-id="element-116">
          <h2 id="how-it-works-heading" className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight" data-id="element-117">
            How It Works
          </h2>
          <div className="w-16 h-1.5 bg-[#4AA6CF] mx-auto rounded-full" aria-hidden="true" data-id="element-118"></div>
        </div>

        <div className="relative" data-id="element-119">
          {/* Connecting dashed line */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 border-t-4 border-dotted border-slate-200 z-0" aria-hidden="true" data-id="element-120"></div>

          <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16 relative z-10" role="list" data-id="element-121">
            {steps.map((step, index) => <motion.li key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.15
          }} className={`flex flex-col items-center text-center group ${index % 2 === 1 ? 'lg:mt-12' : ''}`} data-id="element-122">
                <div className="relative mb-8" data-id="element-123">
                  <div className="w-24 h-24 bg-slate-50 rounded-full shadow-lg flex items-center justify-center border-8 border-white group-hover:border-[#4AA6CF]/20 group-hover:shadow-xl transition-all duration-500" data-id="element-124">
                    <step.icon className="h-10 w-10 text-[#4AA6CF]" aria-hidden="true" data-id="element-125" />
                  </div>
                  <div className="absolute -top-4 -right-4 w-10 h-10 bg-slate-900 text-white rounded-full flex items-center justify-center font-extrabold text-base shadow-lg" aria-hidden="true" data-id="element-126">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-xl font-extrabold text-slate-900 mb-4 tracking-tight" data-id="element-127">
                  {step.title}
                </h3>
                <p className="text-slate-600 leading-relaxed max-w-xs text-base" data-id="element-128">
                  {step.description}
                </p>
              </motion.li>)}
          </ol>
        </div>
      </div>
    </section>;
}